import { Dropdown, Menu } from "antd";
import React from "react";
import styled from "styled-components";

import { COLORS } from "../../constants";
import { Button } from "../Button";
import { EllipsisMenu } from "../Icons";
import { Tooltip } from "../Tooltip";

const ActionsWrap = styled.div`
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding-right: 0;
  background: transparent;
`;

const UserRoleOptionsMenu = styled(Menu)`
  .ant-dropdown-menu-item {
    color: ${COLORS.black85};

    &:hover {
      background: ${COLORS.coeblue};
    }
  }
`;

type Props = {
  onUpdateRole: () => void;
};

export const UserActionMenu: React.FC<Props> = ({ onUpdateRole }) => {
  return (
    <>
      <ActionsWrap className="actionswrap ellipsis">
        <div onClick={e => e.stopPropagation()}>
          <Dropdown
            overlay={
              <UserRoleOptionsMenu>
                <UserRoleOptionsMenu.Item key="rename" onClick={onUpdateRole}>
                  <Tooltip overlayStyle={{ maxWidth: "200px" }}>
                    <div>Manage Role</div>
                  </Tooltip>
                </UserRoleOptionsMenu.Item>
              </UserRoleOptionsMenu>
            }
            trigger={["click"]}
            getPopupContainer={item => item}
          >
            <Button type="text" shape="circle">
              <EllipsisMenu fill={COLORS.black} />
            </Button>
          </Dropdown>
        </div>
      </ActionsWrap>
    </>
  );
};
